import { Button, Container, Heading, Stack } from "@chakra-ui/react"
import { useTheme } from "next-themes"

const Appearance = () => {
  const { theme, setTheme } = useTheme()

  return (
    <>
      <Container maxW="full">
        <Heading size="sm" py={4}>
          Appearance
        </Heading>

        <Stack gap={3} maxW="xs">
          <Button
            size="md"
            variant={theme === "system" ? "solid" : "outline"}
            colorPalette="teal"
            onClick={() => setTheme("system")}
          >
            System
          </Button>
          <Button
            size="md"
            variant={theme === "light" ? "solid" : "outline"}
            colorPalette="teal"
            onClick={() => setTheme("light")}
          >
            Light Mode
          </Button>
          <Button
            size="md"
            variant={theme === "dark" ? "solid" : "outline"}
            colorPalette="teal"
            onClick={() => setTheme("dark")}
          >
            Dark Mode
          </Button>
        </Stack>
      </Container>
    </>
  )
}
export default Appearance
